import type { AxiosError } from "axios";

import { api } from "~/utils/api";

import { insertToast } from "../toasts/services";
import type { ActionsQueryParams, IListActionsDTO } from "./types";

export async function listActions(
	params?: ActionsQueryParams,
	signal?: AbortSignal,
) {
	return api
		.get<IListActionsDTO>("/admin/actions", {
			signal,
			params,
		})
		.then(({ data }) => data)
		.catch((e: AxiosError<APIError>) => {
			const isCanceled =
				(e as any)?.code === "ERR_CANCELED" ||
				(e as any)?.name === "CanceledError" ||
				(e as any)?.name === "AbortError";
			if (isCanceled) return;

			insertToast({
				duration: 4,
				message: e.response?.data?.message || "Erro ao listar ações",
				title: "Erro!",
				type: "error",
			});
		});
}
